module.exports = __webpack_public_path__ + "img/0.5340605e.png";